import { Button, Indicator, Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconLayoutColumns } from "@tabler/icons-react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import StatusContent from "./StatusContent";
import { useMemo } from "react";
import { useLeadsContainerStore } from "../../../../../stores/LeadsStore";

const StatusSettings = ({ disabled }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, { open, close }] = useDisclosure();
  const containers = useLeadsContainerStore((s) => s.containers);

  const hiddenCount = useMemo(() => {
    return containers ? containers.filter((x) => !x.visible)?.length : 0;
  }, [containers]);

  return (
    <>
      <Button
        radius={"md"}
        variant={"subtle"}
        className="test"
        style={{
          borderColor: "var(--mantine-color-primary-0)",
          background: "#fff",
        }}
        onClick={open}
        disabled={disabled}
      >
        <Indicator
          label={hiddenCount}
          color="red"
          offset={2}
          disabled={hiddenCount === 0}
          styles={{
            indicator: {
              fontSize: 9,
              padding: "6px",
            },
          }}
        >
          <IconLayoutColumns size={20} />
        </Indicator>
        <span style={{ marginLeft: 6 }}>
          {lang.table.toolbar.columns.button_label}
        </span>
      </Button>

      {opened && <StatusContent opened={opened} handleClose={close} />}
    </>
  );
};

export default StatusSettings;
